import React from 'react'

export const createEvent = (
  inputRef: React.RefObject<HTMLInputElement | HTMLTextAreaElement>,
  value?: string,
) => {
  if (inputRef.current) {
    const inputEvent = new Event('input')
    const currentTarget = inputRef.current.cloneNode(true) as
      | HTMLInputElement
      | HTMLTextAreaElement
    const customEvent: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement
    > = Object.create(inputEvent, {
      target: { value: currentTarget },
      currentTarget: { value: currentTarget },
    })
    currentTarget.value = value || ''
    return customEvent
  }
}
